// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-song-js": () => import("d:\\github\\guitar-hub\\client\\src\\templates\\song.js" /* webpackChunkName: "component---src-templates-song-js" */),
  "component---src-pages-404-js": () => import("d:\\github\\guitar-hub\\client\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-chords-js": () => import("d:\\github\\guitar-hub\\client\\src\\pages\\chords.js" /* webpackChunkName: "component---src-pages-chords-js" */),
  "component---src-pages-index-js": () => import("d:\\github\\guitar-hub\\client\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-songs-js": () => import("d:\\github\\guitar-hub\\client\\src\\pages\\songs.js" /* webpackChunkName: "component---src-pages-songs-js" */)
}

